import {
  Container,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import React from 'react';
import Background from '../Background';
import Footer from '../Footer';
import Logo from '../Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    // Kit Card primitive (bg-card, 1px border, xl radius). Elevation uses the
    // kit's modal level: card-level shadow (8% grey) is invisible on the dark
    // backdrop, and this card floats over the page like an overlay.
    borderRadius: 'var(--radius-xl)',
    border: '1px solid var(--border)',
    boxShadow: 'var(--shadow-modal)',
    padding: 40,
    minWidth: 340,
    position: 'relative',
    background: 'var(--card)',
    maxHeight: 600,
    overflowY: 'auto',
  },
  // Kit heading-1: 32/38 semibold, --fg-heading
  largeText: {
    fontSize: 'var(--text-heading-1)',
    lineHeight: 'var(--text-heading-1--line-height)',
    fontWeight: 600,
    color: 'var(--fg-heading)',
    paddingBottom: 8,
  },
  largeCenteredText: {
    fontSize: 'var(--text-heading-1)',
    lineHeight: 'var(--text-heading-1--line-height)',
    fontWeight: 600,
    color: 'var(--fg-heading)',
    paddingBottom: 8,
    textAlign: 'center',
  },
  sectionContainer: {
    marginTop: 20,
  },
  sectionLeft: {
    width: 340,
    marginRight: 40,
  },
  sectionRight: {
    width: 340,
    marginLeft: 40,
  },
  message: {
    padding: 10,
    marginTop: 10,
    border: '1px solid var(--orange-300)',
    borderRadius: 'var(--radius-sm)',
    background: 'var(--orange-50)',
    color: 'var(--orange-700)',
    fontSize: 'var(--text-label)',
    lineHeight: 'var(--text-label--line-height)',
  },
}));

interface PageProps {
  title: string;
  centerTitle?: boolean;
  children?: any;
  showRightColumn?: boolean;
  rightColumn?: any;
  message?: string | null;
}

export function Page({
  children,
  title,
  rightColumn,
  showRightColumn = true,
  centerTitle = false,
  message = null,
}: PageProps) {
  const classes = useStyles();

  return (
    <Background>
      <Logo />
      <Footer />
      <Container component="main" className={classes.root}>
        <Paper className={classes.paper}>
          <Typography
            className={
              centerTitle ? classes.largeCenteredText : classes.largeText
            }
          >
            {title}
          </Typography>
          {message && (
            <Paper className={classes.message} elevation={0}>
              {`💡 ${message}`}
            </Paper>
          )}
          {!rightColumn && children}
          {rightColumn && !showRightColumn && children}
          {rightColumn && showRightColumn && (
            <Grid container className={classes.sectionContainer}>
              <Grid item className={classes.sectionLeft}>
                {children}
              </Grid>
              <Grid item>
                <Divider orientation="vertical" />
              </Grid>
              <Grid item className={classes.sectionRight}>
                {rightColumn}
              </Grid>
            </Grid>
          )}
        </Paper>
      </Container>
    </Background>
  );
}
